import { useDroppable } from "@dnd-kit/core"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import { KanbanCard } from "./kanban-card"
import type { Project } from "@/types"

type Props = {
  id: string
  title: string
  color: string
  projects: Project[]
}

export function KanbanColumn({ id, title, color, projects }: Props) {
  const { setNodeRef, isOver } = useDroppable({ id })

  return (
    <div className="flex w-[280px] shrink-0 flex-col">
      <div className="mb-2 flex items-center justify-between rounded-md px-2 py-1.5" style={{ backgroundColor: color }}>
        <h3 className="text-sm font-medium">{title}</h3>
        <span className="rounded-full bg-white/60 px-1.5 text-xs font-medium">{projects.length}</span>
      </div>
      <div
        ref={setNodeRef}
        className={`flex-1 space-y-2 rounded-lg border border-dashed p-2 min-h-[200px] transition-colors ${
          isOver ? "border-primary bg-primary/5" : "border-transparent"
        }`}
      >
        <SortableContext items={projects.map((p) => p.id)} strategy={verticalListSortingStrategy}>
          {projects.map((project) => (
            <KanbanCard key={project.id} project={project} />
          ))}
        </SortableContext>
      </div>
    </div>
  )
}
